import { defineMessages } from 'react-intl'

export default defineMessages({
  requiredIcon: {
    id: 'Asterisk',
    defaultMessage: '*'
  }
})
